import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Recipes from './pages/Recipes';
import Customers from './pages/Customers';
import Assignments from './pages/Assignments';
import Orders from './pages/Orders';
import OrderForm from './pages/OrderForm';
import Production from './pages/Production';
import PrintCentre from './pages/PrintCentre';
import Settings from './pages/Settings';
import CustomerPortal from './pages/CustomerPortal';

function App() {
  return (
    <AppProvider>
      <HashRouter>
        <Routes>
          {/* 1. INTERNAL ADMIN SYSTEM (Protected by Layout/Sidebar) */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="products" element={<Products />} />
            <Route path="recipes" element={<Recipes />} />
            <Route path="customers" element={<Customers />} />
            <Route path="assignments" element={<Assignments />} />
            <Route path="orders" element={<Orders />} />
            <Route path="order-form" element={<OrderForm />} />
            <Route path="production" element={<Production />} />
            <Route path="print" element={<PrintCentre />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* 2. SEPARATE CUSTOMER APP (Standalone, No Admin UI) */}
          {/* We use /portal/ to clearly distinguish it from the internal /order-form/ */}
          <Route path="/portal/:slug" element={<CustomerPortal />} />
          
          {/* Catch-all for the portal if slug is missing */}
          <Route path="/portal" element={<Navigate to="/order-form" replace />} />
          
          {/* Legacy support for the previous link structure if needed */}
          <Route path="/order-form/:slug" element={<Navigate to="/portal/:slug" replace />} />
        </Routes>
      </HashRouter>
    </AppProvider>
  );
}

export default App;